import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdsWithPromosQuery = (query) => ({
  type: actionTypes.SET_ADS_WITH_PROMOS_QUERY,
  payload: query
})
